import { DEFAULT_LANGUAGE } from './constants';
import languages from './languages';
export default function getLanguageDirection(language) {
    const currentLanguage = language && languages[language]
        ? language
        : DEFAULT_LANGUAGE;
    return languages[currentLanguage].direction || 'ltr';
}
export function languageIsRTL(language) {
    return getLanguageDirection(language) === 'rtl';
}
